import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowLeft = props => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path height="100%" width="100%" y="0" x="0" d="m16 7h-12.2l5.6-5.6-1.4-1.4-8 8 8 8 1.4-1.4-5.6-5.6h12.2v-2z" />
  </SvgIcon>
);

export default IconArrowLeft;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowLeft.js